import { FollowUpWorkStatus } from '@nkr/enums/follow-up-work-status';
import { IFollowUpSurvey } from '@nkr/models/follow-up';
import { Panel } from 'react-bootstrap';
import { PanelBodyWrapper } from '../../styles';
import helpers from './helpers';

const Details = (props: { data: IFollowUpSurvey }) => {
    return (
        <Panel>
            <Panel.Heading>Survey Details</Panel.Heading>
            <PanelBodyWrapper>
                <div className='container-fluid'>
                    <div className='row'>
                        <h4 className='text-center'>{props.data.surveyInstance} Survey</h4>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Weight:</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.weightLbs} lbs</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>BMI:</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.bmi}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Last seen by physician:</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.lastSeenByPhysician}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has high blood pressure?:</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.hasHighBp)}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Blood Pressure:</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.bpSystolic}/{props.data.bpDiastolic}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has diabetes?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.hasDiabetes)}</div>
                    </div>

                    {props.data.hasDiabetes && props.data.diabeticUsesInsulin && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>&nbsp; - BG maintained by insulin:</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.diabeticUsesInsulin)}</div>
                        </div>
                    )}

                    {props.data.hasDiabetes && props.data.diabeticUsesOralMeds && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>&nbsp; - BG maintained by oral meds:</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.diabeticUsesOralMeds)}</div>
                        </div>
                    )}

                    {props.data.hasDiabetes && props.data.diabeticUsesDiet && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong> &nbsp; - BG maintained by diet/exercise:</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.diabeticUsesDiet)}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has had complications?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.hadOtherComplications)}</div>
                    </div>

                    {props.data.hadOtherComplications && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.otherComplicationDescription == '' ? '[no comments]' : props.data.otherComplicationDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Required Urgent Care?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.hadUrgentCare)}</div>
                    </div>

                    {props.data.hadUrgentCare && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.urgentCareDescription == '' ? '[no comments]' : props.data.urgentCareDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Physical Capacity?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.physicalCapacity != '' ? props.data.physicalCapacity : '[not answered]'}</div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Percent Functional?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>
                            {helpers.getText(props.data.percentFunctional, props.data.percentFunctional < 100, '%')}
                        </div>
                    </div>

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has Regrets?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.hasRegrets)}</div>
                    </div>

                    {props.data.hasRegrets && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.regretsDescription != '' ? '[no comments]' : props.data.regretsDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Work Status?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>
                            {helpers.getText(props.data.workStatus, props.data.workStatusId != FollowUpWorkStatus.FullTime, '')}
                        </div>
                    </div>

                    {props.data.workStatusId != FollowUpWorkStatus.FullTime && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong>Reason not working full-time?</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.outOfWorkReason}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has lost insurance?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.hasLostInsurance)}</div>
                    </div>

                    {props.data.hasLostInsurance && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Reason</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.lostInsuranceDescription == '' ? '[no comments]' : props.data.lostInsuranceDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Has started dialysis?</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{helpers.getBool(props.data.hasStartedDialysis)}</div>
                    </div>

                    {props.data.hasStartedDialysis && (
                        <div className='row row-underlined'>
                            <div className='col-xs-3'><strong style={{ marginLeft: '10%' }}>Description</strong></div>
                            <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.startedDialysisDescription == '' ? '[no comments]' : props.data.startedDialysisDescription}</div>
                        </div>
                    )}

                    <div className='row row-underlined'>
                        <div className='col-xs-3'><strong>Additional Comments</strong></div>
                        <div className='col-xs-4 col-xs-offset-5 text-center'>{props.data.startedDialysisDescription == '' ? '[no comments]' : props.data.startedDialysisDescription}</div>
                    </div>
                </div>
            </PanelBodyWrapper>
        </Panel>
    )
}

export default Details;